import { render } from "./ChatGroup.vue?vue&type=template&id=36a6a504"
import script from "./ChatGroup.vue?vue&type=script&lang=js"
export * from "./ChatGroup.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__